import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { useLoaderData, useLocation } from "react-router";

import DOMPurify from "dompurify";

import "../../assets/css/wibb/pages/home.scss";
import logo from "../../assets/images/WisconsinBaseballTournaments_Full_Logo_Resize-1.png";
import { alertActions } from "../../features/alert/alertSlice";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { getSiteSetting, printRules } from "../../lib/api";
import { PrintIcon } from "../../lib/icons";
import { IAPIResponse, ISiteSetting } from "../../types/api";

export const loader = async ({ content }: any) => {
    const setting = await getSiteSetting(content);
    return {
        setting,
        content,
    };
};

const Rules = (): React.JSX.Element => {
    const location = useLocation();
    const isClubhousePage = /coachs-clubhouse/.test(location.pathname);

    const {
        setting: {
            setting: { setting: pageContent },
        },
        content: rulesContent,
    } = useLoaderData() as {
        setting: IAPIResponse & {
            setting: ISiteSetting;
        };
        content: string;
    };

    const dispatch = useAppDispatch();

    const handlePrint = async () => {
        dispatch(
            alertActions.warning({
                title: "Generating print file",
                text: "Please wait...",
            }),
        );

        await printRules(rulesContent)
            .then(async response => {
                window.open(response.file, "_blank");
            })
            .catch(e => {
                dispatch(
                    alertActions.error({
                        title: "There was a problem retreving the print file",
                        text: "If the problem persists, please contact a site admin.",
                        dismissible: true,
                    }),
                );
            })
            .finally(() => {
                dispatch(alertActions.clear());
            });
    };

    return (
        <div data-testid="rulesContent" className="rulesContent">
            <Container className={isClubhousePage ? "" : "py-5"}>
                <Row>
                    <Col>
                        <div className="d-flex">
                            <img
                                src={logo}
                                alt="WisconsinBaseballTournaments.com Rules"
                                className="img-fluid"
                            />
                            <PrintIcon
                                className="printerIcon d-none d-lg-inline-block"
                                size="2x"
                                title="Print rules"
                                onClick={handlePrint}
                            />
                        </div>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(pageContent),
                            }}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Rules;
